import { MAX_MOBILE_WIDTH, TABULAR_WIDGET_BREAKPOINT_1 } from '../../../../constants/generic';
import { useIsSmartphoneDevice } from '../../../../hooks/useIsSmartphoneDevice';
import useResizeObserver from '../../../../hooks/useResizeObserver';
import { INormalizedRanking } from '../../../../types';
import { SMPContainer } from '../../atoms/SMPContainer';
import { Table } from '../../molecules/Table';
import { useSizeContext } from '../../contexts/SizeContext';
import { useState } from 'react';
import { TableVariants } from '../../../../constants/sportType';

export interface IRankingProps {
  data: INormalizedRanking[];
  handleParticipantClick?: (id: string | number, name: string) => void;
}

export const Ranking = ({ data, handleParticipantClick }: IRankingProps) => {
  const { setIsMobile } = useSizeContext();
  const [isTableMobile, setIsTableMobile] = useState(false);

  const measuredRef = useResizeObserver((fieldElement) => {
    setIsMobile(fieldElement.offsetWidth < MAX_MOBILE_WIDTH);
    setIsTableMobile(fieldElement.offsetWidth < TABULAR_WIDGET_BREAKPOINT_1);
  });
  const { isMobile: isSmartphoneDevice } = useIsSmartphoneDevice();

  return (
    <>
      {data ? (
        <SMPContainer ref={measuredRef} variant='paddinglessContainer'>
          {data.map(({ name, item }, index) => {
            return (
              <Table
                key={`ranking-row-${index}`}
                groupName={name}
                columns={isTableMobile ?? isSmartphoneDevice ? item?.mobileColumns : item?.desktopColumns}
                rows={item?.data}
                handleClick={handleParticipantClick}
                borderedLogo={true}
                addCustomStyles={true}
                tableVariant={TableVariants.DEFAULT}
              />
            );
          })}
        </SMPContainer>
      ) : null}
    </>
  );
};
